<template>
  <DsPageContent>
    <HeroLogo
      v-if="content.partnerLogo"
      :logo="content.partnerLogo"
    />
    <DsSection
      v-if="content"
      :with-space-top="false"
    >
      <template v-if="isScreenLarge">
        <div class="ds-grid">
          <div class="ds-grid__col ds-grid__col--4">
            <PartnersMetadata
              :metadata="content.partnerMetadata"
              :partner-type="content.partnerType"
              :accreditation-status="content.accreditationStatusCollection"
            />
          </div>
          <div class="ds-grid__col ds-grid__col--7 ds-grid__col--offset-1">
            <PartnersDetailContent :content="content" />
          </div>
        </div>
      </template>
      <template v-else>
        <PartnersDetailContent
          :content="content"
          show-metadata
        />
      </template>
    </DsSection>
    <DsCallToAction
      v-if="content.cta"
      :title="content.cta.title"
      :text="content.cta.text"
      :primary-link="content.cta.primaryLink"
      :secondary-link="content.cta.secondaryLink"
      :with-space-top="false"
    />
  </DsPageContent>
</template>

<script setup>
import { DsPageContent, DsSection, DsCallToAction } from 'awds'

import PartnerDefinitions from '../../../core/data-layer/definitions/partners'
import HeroLogo from '../../../core/components/hero-logo/hero-logo.vue'
import PartnersDetailContent from '@/components/partners/partners-detail-content/partners-detail-content.vue'
import PartnersMetadata from '@/components/partners/partners-metadata/partners-metadata.vue'

const { isScreenLarge } = useScreen()

const { locale } = useI18n()
const { useStandardAsyncData, onBeforeAdyenData, onAfterAdyenData, content } = useMainPageData()
const route = useRoute()
const slug = route.params.slug

await onBeforeAdyenData({ globalDataContentType: PartnerDefinitions.PagePartnersDetail.contentType })

const { data } = await useAsyncData('partners-detail-' + locale.value + slug, async () => {
  const page = await useStandardAsyncData(PartnerDefinitions.PagePartnersDetail, {})

  return {
    pageData: page?.pageData
  }
})

if (content.value?.notificationBar) {
  setNotification(content.value.notificationBar)
}

await onAfterAdyenData(data.value)
</script>
